;(function() {
  'use strict'

  /*
     * Location Service
     *
     * manage a users geolocation data
     *
     */

  Service.$inject = ["$q", "glPrefs", "glAnalytics"];
  angular.module('core.services').factory('locationService', Service)

  // --------------------

  /* @ngInject */
  function Service($q, glPrefs, glAnalytics) {
    var IS_ALLOWED_PREF = 'nearbyIsAllowed'
    var prefs = glPrefs.create('locationService')

    var Errors = {
      1: 'declined',
      2: 'POSITION_UNAVAILABLE',
      3: 'TIMEOUT',
    }

    var options = {
      maximumAge: 30000,
      timeout: 5000,
      enableHighAccuracy: true,
    }

    var geo = {
      latest: {},
      get: get,
      isAllowed: isAllowed,
    }

    init()

    return geo

    function init() {
      get()
    }

    function get(explicitPermission, bypassCache) {
      return $q(function(resolve, reject) {
        // fail if no geolocation
        if (!navigator.geolocation) {
          reject()
          return
        }

        // fail if user has never given explicit permission
        if (!explicitPermission && !isAllowed()) {
          reject()
          return
        }

        // return latest if we have it
        if (geo.latest.position && !bypassCache) {
          resolve(geo.latest)
          return
        }

        trackOnce('asked')

        // otherwise get it!
        navigator.geolocation.getCurrentPosition(
          function(position) {
            trackOnce('accepted')
            setIsAllowed(true)
            setLatestPosition(position)
            resolve(geo.latest)
          },
          function(error) {
            var isBlocked = error.code === _.invert(Errors).declined
            if (isBlocked) {
              trackOnce(Errors[error.code])
              setIsAllowed(false)
            } else {
              glAnalytics.track(
                'Location',
                Errors[error.code] || 'UNKNOWN_ERROR'
              )
            }
            reject(isBlocked)
          },
          options
        )
      })
    }

    function trackOnce(value) {
      var storageKey = 'track-once-' + value
      if (!prefs.get(storageKey)) {
        glAnalytics.track('Location', value)
        prefs.set(storageKey, true)
      }
    }

    function setLatestPosition(position) {
      geo.latest.position = makePosition(position)
      geo.latest.encoded = URIEncodeObject(geo.latest.position)
    }

    function makePosition(position) {
      return {
        coords: {
          accuracy: position.coords.accuracy,
          altitude: position.coords.altitude,
          altitudeAccuracy: position.coords.altitudeAccuracy,
          heading: position.coords.heading,
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          speed: position.coords.speed,
        },
        timestamp: position.timestamp,
      }
    }

    function URIEncodeObject(position, prefix) {
      var str = []
      for (var p in position) {
        if (position.hasOwnProperty(p)) {
          var k = prefix ? prefix + '[' + p + ']' : p
          var v = position[p]
          if (v) {
            str.push(
              typeof v === 'object'
                ? URIEncodeObject(v, k)
                : encodeURIComponent(k) +
                  '=' +
                  encodeURIComponent(v).replace('.', '%2E')
            )
          }
        }
      }
      return str.join('&')
    }

    function isAllowed() {
      return prefs.get(IS_ALLOWED_PREF)
    }

    function setIsAllowed(value) {
      prefs.set(IS_ALLOWED_PREF, value)
    }
  }
})()
